import { TableAction } from "../../utils/tableActions";

interface TableRowProps {
  row: (string | React.ReactNode)[];
  rowIndex: number;
  actions?: TableAction[];
}

const TableRow = ({ row, rowIndex, actions }: TableRowProps) => (
  <tr>
    {row.map((cell, cellIndex) => (
      <td
        key={cellIndex}
        className="whitespace-nowrap px-6 py-4 text-sm text-neutral-900"
      >
        {cell}
      </td>
    ))}
    {actions && actions.length > 0 && (
      <td className="whitespace-nowrap px-6 py-4 text-sm font-medium">
        <div className="flex space-x-2">
          {actions.map((action, actionIndex) => (
            <button
              key={actionIndex}
              onClick={() => action.onClick(rowIndex)}
              className={
                action.className || "text-blue-600 hover:text-blue-900"
              }
            >
              {action.icon}
            </button>
          ))}
        </div>
      </td>
    )}
  </tr>
);

export default TableRow;
